import script from "./Rental.vue?vue&type=script&setup=true&lang=js"
export * from "./Rental.vue?vue&type=script&setup=true&lang=js"

import "./Rental.vue?vue&type=style&index=0&id=23a462db&lang=scss&scoped=true"

import exportComponent from "/Users/andreibratu/Projects/AlibPortfolio/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a462db"]])

export default __exports__